import moment from "moment";
import React from "react";
import { useHistory } from "react-router-dom";
import { ProfileComponent } from "../../components/common/ProfileComponent";
import { CardSummary } from "../../components/databaseAdminComponent/CardSummary";
import { GetErrorMessage } from "../../functions/error";
import { IPaymentTracking } from "../../interfaces/paymentTracking";
import { IPets } from "../../interfaces/pets";
import { getBookingWithDoctorId } from "../../services/booking.service";
import { useError } from "../../store/ErrorModal";
import { useUser } from "../../store/UserStore";

import {
  Container,
  ContainerContent,
  ContainerTimeline,
  HeaderTitle,
  BarContent,
  ContainerBar,
  ContainerDate,
  TextDateBar,
  ScrollContainer,
  ContainerCard,
} from "./index.style";

const colors: string[] = [
  "linear-gradient(270deg, #e94941 0%, #d54151 100%)",
  "linear-gradient(270deg, #E58D3E 0%, #E8B547 100%)",
  "linear-gradient(270deg, #3cefa3 0%, #f6fc5a 100%)",
  "linear-gradient(270deg, #337DCD 0%, #439BCE 100%)",
  "linear-gradient(270deg, #5646ad 0%, #4a68af 100%);",
  "linear-gradient(270deg, #4a68af 0%, #FFF  100%);",
];

export default function DashboardPage() {
  const listDate: number[] = [0, 1, 2, 3, 4, 5, 6, 7];
  const [data, setData] = React.useState<IPaymentTracking[]>([]);
  const [dataCard, setDataCard] = React.useState<IPaymentTracking>();
  const [isLoading, setIsLoading] = React.useState<boolean>(true);
  const { userData } = useUser();
  const { onError } = useError();
  const history = useHistory();
  const getPet = (pets: IPets[], pid: string) =>
    pets.find((pet) => pet.pid === pid);

  const fetchData = React.useCallback(async () => {
    if (!userData?.uid) return history.replace("/login/");

    setIsLoading(true);
    try {
      const res = await getBookingWithDoctorId(userData?.uid);
      setDataCard(res.data[0]);
      setData(res.data);
    } catch (error) {
      onError(GetErrorMessage(error));
    }
    setIsLoading(false);
  }, [userData?.uid, onError, history]);
  React.useEffect(() => {
    fetchData();
  }, [fetchData]);
  const handleChangeTage = async (tags: string[]) => {
    const nData = data.map((item) => {
      if (item.bookingId === dataCard?.bookingId)
        return { ...dataCard, summaryTags: tags };
      else return item;
    });
    setData(nData);
  };
  const handleSubmit = async () => {
    const nData = data.filter((item) => item.bookingId !== dataCard?.bookingId);
    setDataCard(nData[0]);
    setData(nData);
  };
  return (
    <Container>
      <HeaderTitle>
        <h1 className="text-n-color">Dashboard</h1>
        <p className="text-h-color">
          {moment(new Date()).format("ddd, DD MMM YYYY")}
        </p>
      </HeaderTitle>
      <ContainerContent>
        <ScrollContainer>
          <ContainerTimeline>
            {listDate.map((item, index) => {
              const getDate = moment().add(item, "d").format("ddd,DD");
              return (
                <ContainerDate key={index} style={{ left: `${item * 20}%` }}>
                  <p className="text-h-color">{getDate.split(",")[0]}</p>
                  <p className="text-n-color">{getDate.split(",")[1]}</p>
                  <div />
                </ContainerDate>
              );
            })}

            <ContainerBar>
              {[...data].map((item) => {
                const date1 = new Date(
                  item.endDate || new Date(new Date())
                ).getTime();
                const date2 = new Date().getTime();
                const diffTime = Math.abs(date2 - date1);
                let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                let color = colors[diffDays];
                if (date1 < date2) {
                  diffDays = 1;
                  color = colors[0];
                }
                const percen = diffDays === 1 ? 22 : diffDays * 21;
                const pet = getPet(item.pets || [], item.pid);
                return diffDays > 0 ? (
                  <BarContent
                    onClick={() => setDataCard(item)}
                    key={item.bookingId}
                    style={{ width: `${percen}%` }}
                    background={color}
                  >
                    <ProfileComponent
                      style={{ minWidth: 0 }}
                      styleImader={{
                        marginLeft: 0,
                        width: "2.5rem",
                        height: "2.5rem",
                      }}
                      isLightText
                      name={item.displayName}
                      lineId={pet?.petName}
                      avatar={item.imageUrl}
                    />
                    {diffDays > 2 && <TextDateBar>{diffDays} วัน</TextDateBar>}
                  </BarContent>
                ) : (
                  <></>
                );
              })}
            </ContainerBar>
          </ContainerTimeline>
        </ScrollContainer>
        <ContainerCard>
          <CardSummary
            isLoading={isLoading}
            booking={dataCard}
            handleSubmit={handleSubmit}
            handleChangeTage={handleChangeTage}
          />
        </ContainerCard>
      </ContainerContent>
    </Container>
  );
}
